import {useState, useEffect, useRef} from 'react';
import ImageWrapper from '../../ImageWrapper/ImageWrapper';
import Color from "../../../helpers/Color";
import Activity from '../../../helpers/Activity';
import './CategoryOptionV2.css';

function CategoryOptionV2({parent, searchQuery, category, width, marginRight, selected, activeColor, pulseDuration, onClick, metadata}) {
    const wrapperRef = useRef(null);
    const [isHovering, setIsHovering] = useState(false);
    const [pulseEffect, setPulseEffect] = useState(null);
    const [pulseTimeout, setPulseTimeout] = useState(null);

    useEffect(() => {
        startPulseEffect();
    }, []);

    useEffect(() => {
        if (pulseEffect) {
            const timeout = setTimeout(stopPulseEffect, pulseDuration * 1000);
            setPulseTimeout(timeout);
        }
    }, [pulseEffect]);

    useEffect(() => {
        if (pulseEffect) startPulseEffect();
    }, [activeColor]);

    useEffect(() => {
        if (category.focus) startPulseEffect();
    }, [category.focus]);

    const handleMouseEnter = () => {
        setIsHovering(true);
    };

    const handleMouseLeave = () => {
        setIsHovering(false);
    };

    const handleClick = () => {
        if (onClick) {
            Activity.log(metadata, 'category-filter', category.id, selected ? 'deselect' : 'select', true, {parent_id: parent.id, parent_name: parent.name, category_id: category.id, category_name: category.name, search_query: searchQuery || null});
            onClick(category.id);
        }
    };

    const startPulseEffect = () => {
        if (wrapperRef) {
            stopPulseEffect();
            stopPulseTimeout();
            const rgb = Color.hexToRgb(activeColor) || {r: 0, g: 91, b: 128};
            const pulseEffect = wrapperRef.current.animate([
                {boxShadow: `0 0 0 0 rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, 0.9)`},
                {boxShadow: `0 0 0 10px rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, 0)`},
                {boxShadow: `0 0 0 0 rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, 0)`}
            ], {
                duration: 1500,
                iterations: Infinity
            });
            setPulseEffect(pulseEffect);
        }
    };

    const stopPulseEffect = () => {
        if (pulseEffect) {
            pulseEffect.cancel();
            setPulseEffect(undefined);
        }
    };

    const stopPulseTimeout = () => {
        if (pulseTimeout) {
            clearTimeout(pulseTimeout)
            setPulseTimeout(undefined);
        }
    };

    const categoryStyle = () => {
        return {
            width: width ? width : 100,
            minWidth: width ? width : 100,
            marginRight: marginRight ? marginRight : 15
        };
    };

    const imageWrapperStyle = () => {
        return {
            boxShadow: selected ? '0 0 15px rgba(0, 0, 0, 0.188693)' : 'unset',
            transform: `scale(${selected || isHovering ? 1.05 : 1})`,
            border: selected ? `solid 3px ${activeColor}` : 'solid 1px rgba(0, 0, 0, 0.05)'
        };
    };

    const labelStyle = () => {
        return {
            color: selected ? (activeColor ? activeColor : '#005B80') : '#414042',
            fontWeight: selected ? '700' : '400'
        };
    };

    return (
        <div id={category.id} className='category-option-v2' style={categoryStyle()}>
            <div ref={wrapperRef} className={`category-image-wrapper-v2 ${selected ? 'selected' : ''}`} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} onClick={handleClick} style={imageWrapperStyle()}>
                <div className='category-image-v2'>
                    <ImageWrapper
                        image={category.image}
                        alt={category.name}
                        display='block'
                        width={100}
                        height='auto'
                        errorWidth={undefined}
                        errorHeight={undefined}
                        errorPadding={undefined}
                        backgroundColor={undefined}
                        margin={undefined}
                        padding={undefined}
                        borderRadius='100%'
                        transition={true}
                        loadDelay={0}
                        onLoad={undefined}
                    />
                </div>
            </div>
            <p className='category-name-v2' style={labelStyle()}>{category.name || 'Sin nombre'}</p>
        </div>
    );
}

export default CategoryOptionV2;